export default function accordionScript() {

  const accordions = document.querySelectorAll('.c-accordion__accordion');

  const openAccordion = (accordion) => {
    const content = accordion.querySelector('.c-accordion__accordion-content');
    accordion.classList.add('c-accordion__accordion-item--active');
    content.style.maxHeight = content.scrollHeight + 'px';
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector('.c-accordion__accordion-content');
    accordion.classList.remove('c-accordion__accordion-item--active');
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {
  
    const items = accordion.querySelectorAll('.c-accordion__accordion-item');

    if (!items) {
      return;
    }

    items.forEach((item) => {
      const header = item.querySelector('.c-accordion__accordion-item-header');
      const content = item.querySelector('.c-accordion__accordion-content');

      header.onclick = () => {
        if (content.style.maxHeight) {
          closeAccordion(item);
        } else {
          items.forEach((item) => closeAccordion(item));
          openAccordion(item);
        }
      };
    });

    if (accordion.classList.contains('c-accordion--expand-first')) { 
      openAccordion(items[0]);
    }
    
  });
}
